<script setup>
// 홈 — 화면 폭에 따라 데스크톱/모바일 중 하나를 그린다(768 기준).
//
// 퍼블리싱이 두 벌(1920 · 375)이고 동작도 다르다. CSS 로 감추지 않고 컴포넌트 자체를
// 갈아 끼운다 — 한쪽만 마운트되어야 다른 쪽 스크롤 처리가 같이 돌지 않는다.
//
// 데스크톱은 HomeSceneView 다(2026-09-22 교체). 자유 스크롤에 섹션마다 반응형으로
// 옮겨 가는 중인 화면이고, 예전 칸 점프 방식은 HomeDesktopView 에 남아 /legacy 에서 본다.
//
// HomeSceneView 는 데스크톱 전용이다. 여기 분기를 없애면 안 된다 —
// 375 폭에서는 1920 캔버스가 0.195 배로 줄어 아무것도 읽을 수 없다.
import { useIsMobile } from '@/composables/useIsMobile.js'
import HomeSceneView from '@/views/HomeSceneView.vue'
import HomeMobileView from '@/views/HomeMobileView.vue'

const isMobile = useIsMobile()
</script>

<template>
  <HomeMobileView v-if="isMobile" />
  <HomeSceneView v-else />
</template>
